export default __webpack_public_path__ + "static/media/ORALsmall.ff07d377.png";